export default function Input({
  field,
  form,
  label,
  icon,
  type = "text",
  textarea = false,
}) {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className="mb-6">
      {label && (
        <label
          htmlFor={field.name}
          className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-200"
        >
          {label}
        </label>
      )}

      <div
        className={`relative rounded-xl border bg-white transition-all dark:bg-gray-950 ${
          hasError
            ? "border-red-300 ring-4 ring-red-100 dark:border-red-900/50 dark:ring-red-950/30"
            : "border-gray-300 hover:border-gray-400 dark:border-gray-700 dark:hover:border-gray-600"
        } focus-within:border-primary focus-within:ring-4 focus-within:ring-primary/10`}
      >
        {icon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-gray-400 dark:text-gray-500">
            {icon}
          </span>
        )}

        {textarea ? (
          <textarea
            {...field}
            id={field.name}
            rows={4}
            className={`w-full resize-none rounded-xl bg-transparent px-4 py-2.5 text-sm font-medium text-gray-900 outline-none placeholder:text-gray-400 dark:text-gray-100 dark:placeholder:text-gray-500 ${
              icon ? "pl-10" : ""
            }`}
          />
        ) : (
          <input
            {...field}
            id={field.name}
            type={type}
            className={`w-full rounded-xl bg-transparent px-4 py-2.5 text-sm font-medium text-gray-900 outline-none placeholder:text-gray-400 dark:text-gray-100 dark:placeholder:text-gray-500 ${
              icon ? "pl-10" : ""
            }`}
          />
        )}
      </div>

      {hasError && (
        <p className="mt-1.5 text-xs font-medium text-red-600 dark:text-red-400">
          {form.errors[field.name]}
        </p>
      )}
    </div>
  );
}